import { PreScreening } from "./pre-screening.model";

export class PreScreeningAction {
  static readonly type = '[PreScreening] Add item';
  constructor(public payload: string) { }
}

export class GetPreScreening {
  static readonly type = '[PreScreening] Get pre-screening';
}

export class SavePreScreening {
  static readonly type = '[PreScreening] Save pre-screening';
  constructor(public payload: PreScreening) { }
}
